import { AccredibleIconComponentModule } from '@accredible-frontend-v2/components/icon';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ChipComponent } from './chip.component';

const MATERIAL_MODULES = [MatButtonModule, MatIconModule, MatTooltipModule];

@NgModule({
  imports: [CommonModule, AccredibleIconComponentModule, ...MATERIAL_MODULES],
  exports: [ChipComponent],
  declarations: [ChipComponent],
  providers: [],
})
export class AccredibleChipComponentModule {}
